export const PATHS = {
  ROOT: 'payments',
  getExcel: `payments/xlsx/download`,
  getTransferExcel: `payments/xlsx/transfer`,
  getOnedayExcel: `payments/xlsx/oneday`,
  getOneById: (id: number) => `${PATHS.ROOT}/${id}`,
};
